<template>
    <div>
      <b-button variant="outline-light" v-on:click="detayaGit()"
        ><Icon
          icon="ic:baseline-remove-circle"
          width="20"
          height="20"
          v-b-tooltip.hover.bottom="'Sil'"
          color="#EA5455"
      /></b-button>
    </div>
  </template>
  <script>
  import { Icon } from "@iconify/vue2";
  export default {
    components: { Icon },
    methods: {
      detayaGit() {
      //  console.log(this.params.data);
        this.$root.$emit("removeRowRecete", this.params.data);
      }
    }
  };
  </script>
  